function getAccordionsOnPage() {
    
    const accordionTabGroups = document.querySelectorAll('.wp-block-acf-accordion-tab-group');

    for (const accordionTabGroup of accordionTabGroups) {

        checkAccordionGroupPanels(accordionTabGroup.id) //unique id 
        closeAllPanelsExceptCurrent(accordionTabGroup.id)
    }
}

function checkAccordionGroupPanels(accordionID) {

    const accordionElement = document.getElementById(accordionID) //target ID

    const firstPanelOpen = accordionElement.dataset.firstPanelOpen //boolean
    
    const panels = accordionElement.querySelectorAll('details.accordion')

    for (const [index, panel] of panels.entries()) {

        if (index === 0 && firstPanelOpen) {
            
            panel.setAttribute('open',''); //details tag just needs 'open' as an attribute
        }
    }

}

function closeAllPanelsExceptCurrent(accordionID) {

    const accordionElement = document.getElementById(accordionID)
    const panels = accordionElement.querySelectorAll('details.accordion')
    const singlePanelOpen = accordionElement.dataset.singlePanelOpen //boolean

    if (!singlePanelOpen) return; //early return if setting is not active

    for (const panel of panels) {

        panel.setAttribute('name', accordionID) //set the name attribute so the details tag can be grouped together and only one can be open at a time
    }
}



document.addEventListener("DOMContentLoaded", () => {

    getAccordionsOnPage()
})